import { FC } from 'react'

type Props = {
    type?: 'Morfran' | 'Magic API v2' | 'Magic API v1' | 'N/A'
}

const ApiType: FC<Props> = ({ type }) => (
  <div className={`badge ${type=="Morfran"? "badge-light-info":type=="Magic API v2"?"badge-light-warning":"badge-light-primary"} fw-bolder m-1`}>{type}</div>
)

export { ApiType }
